export default __webpack_public_path__ + "locales/sr-Cyrl-RS/InviteDialog.json?hash=138ec1eed27ec81f13dd1392e45140f1";